import { useMutation } from '@tanstack/react-query';
import { withBasePath } from '@/utils/withBasePath';

export function useOrganizerFollowMutation() {
  return useMutation({
    mutationFn: async function postOrganizerFollow(organizerId: string) {
      const res = await fetch(withBasePath(`/api/organizers/${organizerId}/follow/`), {
        method: 'POST',
        credentials: 'include',
      });
      const raw = await res.json();
      return {
        actionPerformed: raw.actionPerformed,
        numFollowers: raw.numFollowers,
        unauthorized: res.status === 401,
      };
    },
  });
}
